(function(root,factory){if(typeof module==='object'&&module.exports)module.exports=factory;else root.EW=factory(root.EW_MODEL);})(typeof globalThis!=='undefined'?globalThis:this,function(M){
'use strict';
const byId=(list)=>Object.fromEntries(list.map(x=>[x.id,x]));
const OCC=byId(M.occasions),EXP=byId(M.experiences),LOC=byId(M.locations),BUD=byId(M.budgets),REC=byId(M.recipients);
const REVEAL_LIMIT=10, MIN_HIDDEN=5;
function initial(){return{recipient:null,participation:null,occasion:null,experience:null,location:null,budget:null};}
function route(s){return['recipient',...(s.recipient==='partner'?['participation']:[]),'occasion','experience','location','budget'];}
function next(s){return route(s).find(k=>!s[k])||'result';}
function today(){const d=new Date();return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');}
function phaseOf(date){date=date||today();if(date>='2026-12-26'&&date<='2026-12-31')return 2;if(date>='2026-11-01'&&date<='2026-12-25')return 1;return 0;}
// ---------- product eligibility ----------
function wantPeople(s){
 const r=s.recipient;
 if(r==='partner')return({one:[1],pair:[2],group:[4,3,6,5],unknown:[2,1]})[s.participation]||[2,1];
 if(r==='couple'||r==='parents')return[2];
 if(r==='family')return[4,3,6,5];
 if(r==='child'||r==='teen')return[2,1];
 return[1];
}
function minorsRule(s){
 if(s.recipient==='child'||s.recipient==='family'||(s.recipient==='partner'&&s.participation==='group'))return'child';
 if(s.recipient==='teen')return'teen';
 return null;
}
function recOk(p,s){
 if(!p.rec.length)return true;
 const r=s.recipient;
 if(r==='other')return false;
 if(r==='teen')return p.rec.includes('teen');
 if(r==='partner'){if(s.participation==='one'||s.participation==='group')return false;return p.rec.includes('partner');}
 if(r==='child')return p.rec.includes('child');
 if(r==='family')return p.rec.includes('family');
 return p.rec.includes(r);
}
function occOk(p,s){
 if(!p.occ.length)return true;
 if(!s.occasion||s.occasion==='other')return false;
 return p.occ.includes(s.occasion);
}
function catOk(p,exp){return exp==='choice'?p.cats.includes('choice'):p.cats.includes(exp);}
function cityOk(p,s){if(!p.city)return true;const loc=LOC[s.location];return !!(loc&&loc.city===p.city);}
function minorsOk(p,s){const m=minorsRule(s);if(!m)return true;if(m==='child')return p.minors==='child';return p.minors==='child'||p.minors==='teen';}
function variantsFor(p,s,band){
 if(p.hold)return [];   // V3.2: product kept in the data but not routed until its price is confirmed
 const want=wantPeople(s);
 let vs=p.v.filter(v=>v.n===null||want.includes(v.n));
 if(band)vs=vs.filter(v=>v.p>=band.min&&v.p<=band.max);
 return vs;
}
function eligible(p,s,exp,opts){
 opts=opts||{};
 if(!recOk(p,s)||!occOk(p,s)||!catOk(p,exp)||!minorsOk(p,s))return false;
 if(!opts.ignoreLocation&&!cityOk(p,s))return false;
 if(opts.ignoreLocation&&p.city)return false;
 const band=opts.band||null;
 return variantsFor(p,s,band).length>0;
}
// V3.2 fallback pool: hero gifts and bucket list gifts (the amount-based gift is no longer a fallback)
function isFallback(p){return p.kind==='hero'||(p.cats.includes('bucketlist')&&(p.kind==='mood'||p.kind==='activity'||p.kind==='city'));}
function fallbackOk(p,s){return isFallback(p)&&recOk(p,s)&&occOk(p,s)&&minorsOk(p,s)&&cityOk(p,s)&&variantsFor(p,s,null).length>0;}
// ---------- ordering ----------
function level(matrix,key,r){return (matrix[key]||{})[r]||'-';}
function occScore(s,o,ph){
 const r=s.recipient,oc=OCC[o],L=level(M.occMatrix,o,r)==='C'?1:0.45,w=(M.W[r]||0);
 const g=M.G.occ[o]||0,c=((M.C.occ[r]||{})[o]);
 const base=(c===undefined||r==='other')?g:((1-w)*g+w*c);
 return oc.mult[ph]*base*L;
}
function expScore(s,e){
 const r=s.recipient,L=level(M.expMatrix,e,r)==='C'?1:0.45,w=(M.W[r]||0);
 const g=M.G.exp[e]||0,c=((M.C.exp[r]||{})[e]);
 const base=(c===undefined||r==='other')?g:((1-w)*g+w*c);
 return base*L;
}
function anyProduct(s,exp){return M.pool.some(p=>eligible(p,s,exp,{ignoreLocation:true}));}  // fallback gifts never make an experience or occasion appear
function experienceOptions(s){
 const r=s.recipient;
 const list=M.experiences.filter(e=>level(M.expMatrix,e.id,r)!=='-'&&anyProduct(s,e.id));
 return list.map(e=>({...e,score:e.id==='choice'?1e9:expScore(s,e.id)})).sort((a,b)=>b.score-a.score);
}
function occasionOptions(s,date){
 date=date||today();const ph=phaseOf(date),r=s.recipient;
 const list=M.occasions.filter(o=>{
  if(level(M.occMatrix,o.id,r)==='-')return false;
  if(o.until&&date>o.until&&date>='2026-09-01'&&date<='2026-12-31')return false;
  if(o.mult[ph]===0&&date>='2026-09-01'&&date<='2026-12-31')return false;
  const t={...s,occasion:o.id};
  return M.experiences.some(e=>level(M.expMatrix,e.id,r)!=='-'&&anyProduct(t,e.id));
 });
 return list.map(o=>({...o,score:o.id==='other'?-1e9:(o.faith?occScore(s,o.id,ph)-1e6:occScore(s,o.id,ph))})).sort((a,b)=>b.score-a.score);
}
function recipientOptions(){return M.recipientOrder.map(id=>REC[id]);}
function locationOptions(){return M.locations;}
function budgetOptions(){return M.budgets;}  // V3.2: all five ranges on every path; a fallback gift covers ranges with no themed gift
function options(key,s,date){
 if(key==='recipient')return recipientOptions();
 if(key==='participation')return M.participation;
 if(key==='occasion')return occasionOptions(s,date);
 if(key==='experience')return experienceOptions(s);
 if(key==='location')return locationOptions();
 if(key==='budget')return budgetOptions(s);
 return[];
}
function reveal(list,key){
 if(key==='location'){const main=list.filter(x=>x.group!=='city').length;return{visible:main,hidden:list.length-main};}  // V3.2: 4 answers, cities behind "See 10 cities"
 const hidden=list.length-REVEAL_LIMIT;return hidden>=MIN_HIDDEN?{visible:REVEAL_LIMIT,hidden}:{visible:list.length,hidden:0};
}
// ---------- state ----------
function apply(s,key,value,date){
 const valid=options(key,s,date).some(o=>o.id===value);
 if(!valid)throw Error('Choose an answer.');
 const n={...s,[key]:value};
 if(s[key]!==value){const order=['recipient','participation','occasion','experience','location','budget'];for(const k of order.slice(order.indexOf(key)+1))n[k]=null;}
 if(n.recipient!=='partner')n.participation=null;
 return n;
}
function progress(s,key){
 const r=route(s),i=key==='result'?r.length:Math.max(0,r.indexOf(key));
 const weights=r.length===6?[30,10,25,15,10,10]:[30,25,20,15,10];
 return{percent:weights.slice(0,i).reduce((a,b)=>a+b,0),number:i+1,total:r.length,remaining:r.length-i,entry:!s.recipient&&i===0};
}
// ---------- recommendation ----------
const KIND={hero:18,theme:14,occasion:12,mood:12,city:12,activity:6};
function locBoost(p,loc){if(!loc||!loc.boost)return 0;let b=0;for(const [cat,pts] of Object.entries(loc.boost))if(p.cats.includes(cat))b=Math.max(b,pts);return b;}
// ---------- V3.3 named gifts: one live product per occasion, recipient and price ($99 · $149 · $249 · $399 · $599) ----------
const NAMED=(M.named&&M.named.groups)||[];
const BAND_PRICE=(M.named&&M.named.bandPrice)||{};
function namedGroup(s){
 if(!s.occasion)return null;
 for(const g of NAMED){
  if(!g.curated||g.occasion!==s.occasion)continue;
  if(s.recipient==='partner'){if((g.partner||[]).includes(s.participation))return g;continue;}
  if((g.recipients||[]).includes(s.recipient))return g;
 }
 return null;
}
function namedItem(g,s){
 const band=BUD[s.budget],want=BAND_PRICE[s.budget];
 let pr=g.products.find(x=>x.p===want),top=false;
 if(!pr){pr=g.products.reduce((a,b)=>b.p>a.p?b:a);top=true;}   // group has no product at this price: use its highest
 return{product:{h:pr.h,title:g.title,kind:'named',layer:'HERO',cats:[],occ:[g.occasion],rec:g.recipients||[],minors:null,city:null,rt:null,rc:0,group:g.id},
  variant:{id:pr.vid,t:pr.t,p:pr.p,n:null},score:0,match:'named',inBand:pr.p>=band.min&&pr.p<=band.max,topOfGroup:top,
  url:'https://everwow.com/products/'+pr.h+'?variant='+pr.vid};
}
// the named gift's experience list covers this answer (Let them choose, or not on the group's keep list)
function namedCovers(g,s){return s.experience==='choice'||!(g.keep||[]).includes(s.experience);}
const isHero=p=>p.layer==='HERO';
function recommend(s,date){
 if(next(s)!=='result')return{state:'incomplete',items:[]};
 const band=BUD[s.budget];
 const loc=LOC[s.location];
 const state0=s.location==='outside'?'R03':'R01';
 const g=namedGroup(s);
 const named=()=>({state:state0,items:[namedItem(g,s)],count:1,match:'named'});
 if(g&&namedCovers(g,s))return named();
 const mid=band.mid!=null?band.mid:(band.min+band.max)/2,width=Math.max(1,band.span!=null?band.span:band.max-band.min);  // open top band scores around its mid
 const want=wantPeople(s),pref=v=>v.n===null?0:want.indexOf(v.n);
 const items=[];
 const HERO_BELOW=50;                                   // a single-price hero may sit up to $50 under the range before per-person products are used
 const heroBand={min:Math.max(0,band.min-HERO_BELOW),max:band.max};
 for(const p of M.pool){
  const b2=isHero(p)?heroBand:band;
  if(!eligible(p,s,s.experience,{band:b2}))continue;
  const vs=variantsFor(p,s,b2).sort((a,b)=>{const ia=a.p>=band.min?0:1,ib=b.p>=band.min?0:1;return ia-ib||pref(a)-pref(b)||Math.abs(a.p-mid)-Math.abs(b.p-mid)||a.p-b.p;});
  const v=vs[0];
  let score=KIND[p.kind]||0;
  if(p.occ.includes(s.occasion))score+=60;
  if(p.rec.includes(s.recipient))score+=35;
  if(p.city&&loc&&loc.city===p.city)score+=30;
  if(s.experience!=='choice'&&p.cats.length===1&&p.cats[0]===s.experience)score+=8;
  score+=locBoost(p,loc);
  if(p.bs)score+=6;
  score-=10*Math.abs(v.p-mid)/width;
  if(v.p<band.min)score-=12;                           // under the range: still a hero, but an in-range hero wins at equal fit
  items.push({product:p,variant:v,score:Math.round(score*100)/100,match:'themed',inBand:v.p>=band.min&&v.p<=band.max,url:'https://everwow.com/products/'+p.h+'?variant='+v.id});
 }
 const sortI=a=>a.sort((x,y)=>y.score-x.score||x.variant.p-y.variant.p||x.product.h.localeCompare(y.product.h));
 const heroes=items.filter(i=>isHero(i.product));
 if(heroes.length){sortI(heroes);return{state:state0,items:heroes.slice(0,1),count:items.length,match:'themed'};}
 if(g)return named();                                  // a single-price named gift beats per-person products
 if(items.length){sortI(items);return{state:state0,items:items.slice(0,1),count:items.length,match:'themed'};}
 // fallback: a hero or bucket list gift that suits the recipient's age group and occasion, priced as close to the range as possible
 const target=band.fbt!=null?band.fbt:mid;
 const fb=[];
 for(const p of M.pool){
  if(!fallbackOk(p,s))continue;
  const vs=variantsFor(p,s,null).sort((a,b)=>{const ia=(a.p>=band.min&&a.p<=band.max)?0:1,ib=(b.p>=band.min&&b.p<=band.max)?0:1;return ia-ib||pref(a)-pref(b)||Math.abs(a.p-target)-Math.abs(b.p-target)||a.p-b.p;});
  const v=vs[0];
  const inBand=v.p>=band.min&&v.p<=band.max;
  let score=inBand?40:0;
  score-=Math.abs(v.p-target)/10;                      // $10 away = 1 point
  if(s.experience!=='choice'&&p.cats.includes(s.experience))score+=30;
  if(p.occ.length&&p.occ.includes(s.occasion))score+=25;
  if(p.rec.length&&p.rec.includes(s.recipient))score+=20;
  if(p.cats.includes('bucketlist'))score+=8;
  if(p.kind==='hero')score+=6;
  if(p.city&&loc&&loc.city===p.city)score+=10;
  score+=locBoost(p,loc)/2;
  if(p.bs)score+=4;
  score+=(p.rt||0);                                    // rating as a light tiebreak
  fb.push({product:p,variant:v,score:Math.round(score*100)/100,match:'fallback',inBand,url:'https://everwow.com/products/'+p.h+'?variant='+v.id});
 }
 const fbHeroes=fb.filter(i=>isHero(i.product)),fbPool=fbHeroes.length?fbHeroes:fb;
 if(!fbPool.length)return{state:'R02',items:[],count:0,match:'fallback'};
 sortI(fbPool);
 return{state:state0,items:fbPool.slice(0,1),count:fb.length,match:'fallback'};
}
function label(key,id){const src={recipient:M.recipients,participation:M.participation,occasion:M.occasions,experience:M.experiences,location:M.locations,budget:M.budgets}[key]||[];return(src.find(x=>x.id===id)||{}).label||'';}
function restore(raw,date){
 let s=initial();if(!raw||typeof raw!=='object')return s;
 for(const key of ['recipient','participation','occasion','experience','location','budget']){if(raw[key]&&route(s).includes(key)){try{s=apply(s,key,raw[key],date);}catch(e){break;}}}
 return s;
}
return{initial,route,next,apply,options,reveal,progress,recommend,label,restore,phaseOf,today,eligible,variantsFor,fallbackOk,isFallback,namedGroup,namedItem,namedCovers,REVEAL_LIMIT,MIN_HIDDEN};
});

